export const CRP_CLIENTS_LIST_KEYS = {
    EMAIL: "email",
    FIRST_NAME: "firstName",
    LAST_NAME: "lastName",
    IS_ACTIVE: "isActive",
    EMAIL_LOGS:"emailLogs",
    CLIENT_NAME: "clientName"
}

export const CRP_CLIENTS_TABLE_HEADERS = {
    [CRP_CLIENTS_LIST_KEYS.EMAIL]: "Email",
    [CRP_CLIENTS_LIST_KEYS.CLIENT_NAME]:"Client Name",
    [CRP_CLIENTS_LIST_KEYS.FIRST_NAME]:"First Name",
    [CRP_CLIENTS_LIST_KEYS.LAST_NAME]:"Last Name",
    [CRP_CLIENTS_LIST_KEYS.IS_ACTIVE]:"Active Status",
    [CRP_CLIENTS_LIST_KEYS.EMAIL_LOGS]:"Email Logs",
}